import {array, object, string} from 'yup';

export const quizFormValidationSchema = object().shape({
  pluginMetadata: object().shape({
    targetURL: string().required('Target URL is required'),
    questions: array().of(
      object().shape({
        title: string().required('Question text is required'),
        answers: array()
          .of(string().required())
          .min(2, 'At least 2 answer options are required'),
        correctAnswer: string().required('Correct answer is required')
      })
    ).min(1, 'At least one question is required'),
    formSettings: object().shape({
      pages: array().min(1, 'At least one question is required').of(object().shape({
        elements: array().of(object().shape({
          title: string().required(),
          choices: array().of(string().required()).min(2, 'At least two answers are required').required()
        }))
      }))
    })
  }),
});
